var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#86123e",
    d: "M14.45 4a2.86 2.86 0 0 0-4.9 0L1.67 16.87a2.87 2.87 0 0 0 2.45 4.36h15.76a2.87 2.87 0 0 0 2.45-4.36z",
    opacity: 1,
    "data-original": "#ed4040",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.75a.76.76 0 0 1-.75-.75V9.5a.75.75 0 0 1 1.5 0V14a.76.76 0 0 1-.75.75z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.5,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningA);
export default __webpack_public_path__ + "static/media/warning-a.f66a61bbf714e51665779dda71506a49.svg";
export { ForwardRef as ReactComponent };